import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as myGlobals from '../app.component';
import { User } from '../models/user.model';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  user: User;

  private baseUrl = myGlobals.baseUrl;

  constructor(private http: HttpClient) {
    this.user = null;
  }

  getUserType() {
    return this.http.get(`${this.baseUrl}/getUserType`);
  }

  getUser(data) {
    return this.http
      .post(`${this.baseUrl}/getUser`, data)
      .toPromise()
      .then((data) => {
        if (data['type'] == 'Success') {
          this.user = new User(
            data['user']['id'],
            data['user']['first_name'],
            data['user']['last_name'],
            data['user']['username'],
            data['user']['email'],
            data['user']['phone'],
            data['user']['last_login'],
            data['user']['birthday'],
            data['user']['status'],
            data['user']['address'],
            data['user']['avatar'],
            data['user']['role']
          );
        }
        return this.user;
      })
      .catch((data) => {
        return null;
      });
  }
  getGuidelines(data) {
    return this.http.get(`${this.baseUrl}/getGuidelines?role_id=${data}`);
  }

  getUserId() {
    return this.http.post(`${this.baseUrl}/getUser`, null);
  }

  activeUser(data) {
    return this.http.post(`${this.baseUrl}/activeUser`, data);
  }

  blockUser(data) {
    return this.http.post(`${this.baseUrl}/blockUser`, data);
  }

  getLanguages(){
    return this.http.get(`${this.baseUrl}/getLanguages`);
  }
  savePreferance(data){
    return this.http.post(`${this.baseUrl}/savePreferance`,data);
  }

  resetPassword(data){
    return this.http.post(`${this.baseUrl}/resetPasswordAfterLogin`,data);
  }
}
